/**
 * created by xiao cheng chen on 2021/2/1
 */
import React, { Component } from 'react';
import { TreeSelect, Row, Icon, Col, Empty, Pagination, message } from 'antd';
import { HEADER_HEIGHT } from "../../constants";
import { Scrollbars } from "react-custom-scrollbars";
import * as utils from "../../utils/index";
import {connect} from "react-redux";
// import { getClueManageList, getClueadoptData } from '../../actions/clueManage'
import * as Action from '../../actions/clueManage'
import ClueManageList from "../components/clueManage/ClueManageList"
import eventProxy from "../../utils/eventProxy"

const typeList = [
    {
        title: "全部",
        value: 1000,
        key: "0",
    },
    {
        title: "已采用",
        value: 1,
        key: "1",
    },
    {
        title: "已弃用",
        value: 2,
        key: "2",
    }
];

class ClueManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start: 1, //当前页
            size: 10, //每页条数
            dataList: [], //数据源,
            listTotal: 0, //列表总数
            typeKey: 1000, //状态筛选
            clueId: {}, //线索id
            pictureData:[],
            videoData:[],
            attachmentFileData:[],
        };
    }
    componentDidMount() {
        this.pageChange();
    }
    pageChange() {
        let params = {
            start: this.state.start,
            size: this.state.size,
        }
        if (this.state.typeKey) {
            params.status = this.state.typeKey
        }
        Action.getClueManageList(params, (res) => {
            console.log(res)
            let listTotal = 0;
            let dataList = [];
            if (res && res.data) {
                listTotal = res.count;
                dataList = res.data
            }
            this.setState({
                listTotal,
                dataList
            })
        })

    }
    // 转为单独活动
    transferAloneActivity(transid) {
        var url = "#/interviewTask/interviewTask/1/" + transid;
        window.location.hash = url;
    }
    // 转为选题报道
    transferTopicReport(transid) {
        var url = "#/interviewTask/interviewTask/2/" + transid;
        window.location.hash = url;
    }
    // 采用
    getClueadoptDatas(adoptID, inputValue) {
        if (inputValue) {
            let params = {
                id: adoptID,
                revirew_content: inputValue,
            }
            Action.getClueadoptData(params, (res) => {
                if (res) {
                    message.success("采用成功")
                } else {
                    message.error("采用失败")
                }
                this.pageChange()
            })
        } else {
            message.info("采用原因不能为空")
        }

    }
    // 弃用
    getClueabandonDatas(adoptID, inputValue) {
        if (inputValue) {
            let params = {
                id: adoptID,
                revirew_content: inputValue,
            }
            Action.getClueabandonData(params, (res) => {
                if (res) {
                    message.success("弃用成功")
                } else {
                    message.error("弃用失败")
                }
                this.pageChange()
            })
        } else {
            message.info("弃用原因不能为空")
        }

    }
    render() {
        let newSecondSelectColor = this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        let height = window.innerHeight - HEADER_HEIGHT; //上部分70//
        return (
            <div style={{margin:"20px"}}>
                <div
                    style={{
                        backgroundColor: "#fff",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "42px",
                            lineHeight: "42px",
                            padding: "0 15px",
                            borderBottom: "1px solid #f6f6f6",
                            color:newSecondSelectColor,
                            borderRadius: "2px 2px 0 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                        }}
                    >
                        线索管理
                    </div>
                    <div style={{ display: "flex", alignItems: "center", padding: "15px 0px 15px 15px" }}>
                        <div>筛选<span style={{ marginLeft: "10px" }}>|</span></div>
                        <div style={{ marginLeft: "20px" }}>
                            <TreeSelect
                                style={{ width: "200px" }}
                                value={this.state.typeKey}
                                treeData={typeList}
                                onChange={(value) => {
                                    this.state.typeKey = value;
                                    this.state.start = 1;
                                    this.state.size = 10;
                                    this.setState({});
                                    this.pageChange();
                                }}
                            />
                        </div>
                        <div>
                            <span style={{ marginLeft: "15px", cursor: "pointer" }} onClick={this.clearNull}>
                                重置
                            </span>
                        </div>
                    </div>
                </div>
                {/* 列表 */}
                <div
                    style={{ padding: "15px" }}
                >
                    <Row justify="start">
                        {/* 全选 */}
                        <Col span={10}>
                            标题
            </Col>
                        <Col span={4} style={{ textAlign: "center", position: "relative" }}>
                            {/* <div style={{ position: "absolute", bottom: "25%", left: "64%" }}>
                                <div style={{ height: "10px" }}>
                                    <Icon onClick={this.ascendingOrder} className="clueTimeSort" type="caret-up" />
                                </div>
                                <div style={{ height: "10px" }}>
                                    <Icon onClick={this.descendingOrder} className="clueTimeSort" type="caret-down" />
                                </div>
                            </div> */}

                            提交时间
            </Col>
                        <Col span={4} style={{ textAlign: "center" }}>
                            状态
            </Col>
                        <Col span={6} style={{ textAlign: "center" }}>
                            操作
            </Col>
                    </Row>
                </div>
                {/* 处理滚动条的方法以及自适应 */}
                <div style={{ height: height - 220, background: "white" }}>
                    <Scrollbars ref={(Scrollbars) => (this.scrollRef = Scrollbars)}>
                        {/* 循环组件 */}
                        {/* 无数据时显示为暂无数据 */}
                        {
                            this.state.dataList.length === 0 ? <Empty style={{ position: "absolute", top: "45%", left: "45%" }} /> : null
                        }
                        {
                            this.state.dataList.map((item, index) => {
                                return (
                                    <ClueManageList
                                        key={item.id}
                                        id={item.id}
                                        title={item.title}
                                        status={item.status}
                                        isinterview={item.isinterview}
                                        contacts={item.contacts}  //联系人
                                        contactsWay={item.contactsWay}  //联系方式
                                        submitter={item.submitter}  //操作人
                                        review_content={item.review_content}  //采用原因
                                        submitTime={
                                            item.submitDate && item.submitDate.time
                                                ? utils.formatDate(item.submitDate.time)
                                                : ""
                                        }
                                        getClueadoptDatas={(adoptId, inputValue) => this.getClueadoptDatas(adoptId, inputValue)}
                                        getClueabandonDatas={(adoptId, inputValue) => this.getClueabandonDatas(adoptId, inputValue)}
                                        transferAloneActivity={() => this.transferAloneActivity(item.id)}
                                        newsClueView={() => this.newsClueView(item.id)}
                                        newsClueAdd={() => this.newsClueAdd(item.id)}
                                        getClueIds={() => this.getClueIds(item.id)}
                                        getPictures={() => this.getPictures(item.id)}
                                        getVideos={() => this.getVideos(item.id)}
                                        getAttachments={() => this.getAttachments(item.id)}
                                        clueId={this.state.clueId}
                                        pictureData={this.state.pictureData}
                                        videoData={this.state.videoData}
                                        attachmentFileData={this.state.attachmentFileData}
                                        newSecondSelectColor={newSecondSelectColor}
                                    />
                                );
                            })}
                    </Scrollbars>
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "10px",
                    }}
                >
                    <Pagination
                        showQuickJumper
                        current={this.state.start}
                        pageSize={this.state.size}
                        total={this.state.listTotal}
                        showTotal={(total) => `共 ${total} 条`}
                        // showSizeChanger
                        onChange={(page, pageSize) => this.onChange(page, pageSize)} //页码改变时回调
                        onShowSizeChange={(page, pageSize) => {
                            this.onChange(page, pageSize); //每页条数改变回调
                        }}
                    />
                </div>
            </div>
        );
    }
    onChange = (page, pageSize) => {
        this.state.start = page;
        this.state.size = pageSize;
        this.pageChange();
    };
    clearNull = () => {
        this.setState({
            start: 1,
            size: 10
        })
        this.state.typeKey = 1000
        this.pageChange();
    }
    // 转为任务
    newsClueAdd(clueId) {
        window.location.hash = `/newsActivityIndex/newsActivityIndex`;
        setTimeout(() => {
            eventProxy.trigger('newsClueAdd', clueId);
        }, 1);
    }
    // 查看任务
    newsClueView(clueId) {
        window.location.hash = `/newsActivityIndex/newsActivityIndex`;
        setTimeout(() => {
            eventProxy.trigger('newsClueView', clueId);
        }, 1);
    }
    // 获取线索id
    getClueIds(clueId) {
        let params = {
            id: clueId,
        }
        Action.getClueId(params, (res) => {
            console.log(res);
            let clueId=[];
            if(res){
                clueId=res;
            }
            this.setState({
                clueId
            })
        })

    }
    // 获取图片
    getPictures(clueId) {
        let params = {
            id: clueId,
        }
        Action.getPicture(params, (res) => {
            console.log(res);
            let pictureData=[];
            if(res){              
                pictureData=res;             
            }
            this.setState({
                pictureData
            })
        })

    }
    // 获取视频
    getVideos(clueId) {
        let params = {
            id: clueId,
        }
        Action.getVideo(params, (res) => {
            console.log(res);
            let videoData=[];
            if(res){
                videoData=res;     
            }
            this.setState({
                videoData
            })
        })

    }
    // 获取附件
    getAttachments(clueId) {
        let params = {
            id: clueId,
        }
        Action.getAttachment(params, (res) => {
            console.log(res);
            let attachmentFileData=[];
            if(res){
                attachmentFileData=res;
            }
            this.setState({
                attachmentFileData
            })
        })

    }

    // ascendingOrder = () => {
    //     this.state.dataList.sort(clueSort("submitDate.time", true))
    //     this.setState({})
    // }
    // descendingOrder = () => {
    //     // 这里变量要加""
    //     // 姓名按字符串编码降序排序
    //     // clueSort函数 第一个参数为需要排序的字段 第二个参数 false 为降序 true为升序
    //     this.state.dataList.sort(clueSort("submitDate.time", false))
    //     this.setState({})
    // }

}
// // 排序
// function clueSort(prop, rev) {
//     // 第二个参数没有传递，默认升序排序
//     if (rev === undefined) {
//         rev = 1;
//     } else {
//         rev = rev ? 1 : -1;
//     }
//     return function (obj1, obj2) {
//         // 方括号也是访问对象属性的一种方式，优点是可以通过变量访问。
//         // 常规写法是 var val1 = obj1.prop;var val2 = obj2.prop;,但是这种不支持变量写法，所有这里不适用
//         var val1 = obj1[prop],
//             val2 = obj2[prop];
//         // 若是升序排序，此时rev=1,rev*-1=-1,等价于return val1 < val2 ? -1 : 1,，即val1<val2时，val1放在val2前面，否则放后面
//         // 若是降序排序，下面句子等价于return val1 < val2 ? 1 : -1，即val1<val2时，val1放在val2后面，否则放在val2前面
//         return val1 < val2 ? rev * (-1) : rev * 1;
//     }
// }
function mapStateToProps(state){
    return {
        currentUser: state.systemReducer.currentUser,
        sysConfig : state.systemReducer.config,
    }
}

export default (connect(mapStateToProps)(ClueManage));